import React from "react"
import styled from 'styled-components'
import {media} from "utils/Media"

const ButtonStyled = styled.button`
    cursor: pointer;
    border: 0;
    outline: 0;
    text-decoration: none;
    background: none;
    color: ${props => props.theme.colors.white};
    line-height: 20px;
    
    @media ${media.sm} {
      line-height: 40px;
    }
`

export default props => <ButtonStyled {...props} />